import { Button } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import PagesContainer from "../../../components/UI/PagesContainer";
import useFetch from "../../../hooks/useFetch";
import { ScheduleInsuranceService } from "../../Schedule/Insurance/insurance.service";
import InsuranceTable from "../../Schedule/Insurance/InsuranceTable/InsuranceTable";
import { IInsuranceFavorite } from "../../Schedule/Insurance/model";

const formatInsuranceName = (insurance: IInsuranceFavorite) =>
  insurance.categoryName
    ? `${insurance.insuranceName} (${insurance.categoryName})`
    : insurance.insuranceName;

const Insurance = () => {
  const [insurances, setInsurances] = useState<IInsuranceFavorite[]>([]);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const { sendRequest, loading } = useFetch(ScheduleInsuranceService.list);

  const fetch = useCallback(async () => {
    const { data, success } = await sendRequest(undefined);

    if (data && success) {
      setInsurances(data);
    }
  }, [sendRequest]);

  const handleDelete = useCallback((id: string) => {
    setInsurances((data) => data.filter((insurance) => insurance.code !== id));
  }, []);

  const rows = useMemo(
    () =>
      insurances.map((insurance) => ({
        ...insurance,
        insuranceName: formatInsuranceName(insurance),
      })),
    [insurances]
  );

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <PagesContainer
      title={t("page.schedules.insurance.title")}
      subtitle={t("page.schedules.insurance.subtitle")!}
      rowActions={
        <Button variant="contained" onClick={() => navigate("add")}>
          {t("page.schedules.insurance.add")}
        </Button>
      }
    >
      <InsuranceTable
        insurance={rows}
        onDelete={handleDelete}
        loading={loading}
      />
    </PagesContainer>
  );
};

export default Insurance;
